import { supportedLangsByCode, type LangEnum } from '@/constants/locales'

export function replaceLangInPath(currentPath: string, nextLang: string) {
  return currentPath.replace(/\/([^/]+)?/, `/${nextLang}`)
}

export function checkLangSupported(lang: string): lang is LangEnum {
  return lang in supportedLangsByCode
}
